import { observable } from "@chorda/core";
import { Button, Card, Modal, RowLayout } from "chorda-bulma";
import { LOREM_IPSUM_HTML } from "../../data";
const isOpened = observable(false);
export default () => {
    return RowLayout([
        Button({
            text: 'Open modal',
            onClick: () => {
                isOpened.$value = !isOpened.$value;
            }
        }),
        Modal({
            content: Card({
                content: {
                    html: LOREM_IPSUM_HTML
                }
            }),
            active$: () => isOpened
        })
    ]);
};
